import { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import GetIcon from "../../../../utils/Icon";
import Tab1 from "./Tab1";
import printerimg from "../../../../assets/print.png";
import { usePostUpdatePaymentTermTemplateMutation, useGetItemDetailsDataMutation } from "../../../../store/api/itemapi";
import ApiResponseBox from "../../../../Components/ApiResponseBox";
import Button from "../../../../Core/Button/Button";
import FormLayoutTwo from "../../../../Core/Layout/FormLayoutTwo";
import FileAttachmentManager from "../../../../Components/FileAttachmentManager";
import Attachment from "../../../../utils/Attachment";
import { usePageState } from "../../../../Hook/usePageState";
import { isStateChanged } from "../../../../utils/stateComparator";
const EditForm = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const IdData = location.state?.ItemId;
  const [podata, setpodata] = useState('')
  const [podate, setpodate] = useState(new Date().toISOString().split("T")[0]);
  const [error, setError] = useState("");
  const [ptype, setptype] = useState("Error");
  const [finalstep, setfinalstep] = useState(false);
  const [showError, setShowError] = useState(false);

  // api varibale
  const [UpdatePaymentTermsTemplate] = usePostUpdatePaymentTermTemplateMutation();



  const [po_response, setpo_response] = useState("");

  const [fieldErrors, setFieldErrors] = useState({
    TemplateName: false,
  });

  const pageStateDefault = {
    tab: 1,
    TemplateName: '',
    AllocatePaymentBasedOnPaymentTerms: false,
    selected_payment_term_data: [{
      payment_term: "",
      description: "",
      due_date_based_on: "",
      invoice_portion: "",
      credit_days: ""
    }],
  };

  const [pageState, setPageState] = usePageState(`Edit Payment Terms Template - ${IdData}`, pageStateDefault);


  const { tab, TemplateName, AllocatePaymentBasedOnPaymentTerms, selected_payment_term_data } = pageState;

  const [AttachmentsList, setAttachmentsList] = useState([]); // ✅ Make sure it's an array
  const [itemDetails, { data, isLoadin }] = useGetItemDetailsDataMutation();

  useEffect(() => {
    if (!isStateChanged(pageState, pageStateDefault)) {
      if (IdData) {
        itemDetails({ doctype: 'Payment Terms Template', name: IdData })
          .unwrap()
          .then((response) => {
            const item = response.docs?.[0]; // ✅ safely access first item
            const docinfo = response.docinfo;

            if (!item) return;
            setpodata(response)
            setPageState({
              ...pageState,
              TemplateName: item.template_name,
              AllocatePaymentBasedOnPaymentTerms: item.allocate_payment_based_on_payment_terms,
              selected_payment_term_data: item.terms,


            });

            setAttachmentsList(docinfo.attachments); // ✅ Correct place
          })
          .catch((err) => {
            console.error('API Error:', err);
          });
      } else {
        console.warn('No Id Data found in location state');
      }
    }
  }, [IdData, itemDetails]);


  const handleSubmit = async () => {
    // 🔹 Step 1: Calculate total invoice portion (rounded)
    const totalPortion = selected_payment_term_data.reduce(
      (sum, row) => sum + (parseFloat(row.invoice_portion) || 0),
      0
    );

    const roundedTotal = Math.round(totalPortion * 100) / 100;
console.log('iv:',selected_payment_term_data)
    if (roundedTotal !== 100) {
      setptype("Error");
      setError(`Combined invoice portion must equal 100% (Currently ${roundedTotal}%)`);
      setShowError(true);
      return;
    }

    // 🔹 Step 2: Validate Template Name
    const newErrors = { TemplateName: !TemplateName };
    setFieldErrors(newErrors);
    if (!TemplateName) {
      setptype("Error");
      setError("Please fill Template Name.");
      setShowError(true);
      return;
    }

    // 🔹 Step 3: Prepare payload
    const payload = {
      template_name: IdData,
      allocate_payment_based_on_payment_terms: AllocatePaymentBasedOnPaymentTerms,
      terms: selected_payment_term_data || [],
    };

    console.log("update payment terms template payload:", payload);

    // 🔹 Step 4: Call API
    try {
      const response = await UpdatePaymentTermsTemplate(payload).unwrap();

      // ✅ Check if backend returned an error structure
      if (response.error) {
        let errorMessage = "Updation failed";

        try {
          if (response._server_messages) {
            // Parse frappe _server_messages JSON
            const serverMsgs = JSON.parse(response._server_messages);
            if (Array.isArray(serverMsgs) && serverMsgs.length > 0) {
              const parsed = JSON.parse(serverMsgs[0]);
              errorMessage = parsed.message || errorMessage;
            }
          } else if (response.error.data?.message) {
            errorMessage = response.error.data.message;
          } else if (response.error.data?.exception) {
            errorMessage = response.error.data.exception;
          }
        } catch (err) {
          console.warn("Error parsing server message", err);
        }

        // ✅ Clean HTML (just in case)
        const doc = new DOMParser().parseFromString(errorMessage, "text/html");
        errorMessage = doc.body.textContent || "Unexpected error";

        setptype("Error");
        setError(errorMessage);
        setShowError(true);
        return;
      }

      // 🔹 Step 5: Success response
      setpo_response(response.data);
      setError("Payment Terms Template updated successfully!");
      setptype("Success");
      setShowError(true);

      setTimeout(() => {
        navigate("/master/payment-term-template/payment-term-template-list");
      }, 2000);
    } catch (err) {
      console.error("API error:", err);

      let cleanMessage = "Unexpected error occurred.";
      try {
        if (err.data?._server_messages) {
          const serverMsgs = JSON.parse(err.data._server_messages);
          if (Array.isArray(serverMsgs) && serverMsgs.length > 0) {
            const parsed = JSON.parse(serverMsgs[0]);
            cleanMessage = parsed.message || cleanMessage;
          }
        } else if (err.data?.message) {
          cleanMessage = err.data.message;
        } else if (err.data?.exception) {
          cleanMessage = err.data.exception;
        }

        // Clean HTML tags if present
        const doc = new DOMParser().parseFromString(cleanMessage, "text/html");
        cleanMessage = doc.body.textContent || cleanMessage;
      } catch (e) {
        console.warn("Error cleaning API message", e);
      }

      setptype("Error");
      setError(cleanMessage);
      setShowError(true);
    }
  };


  return (
    <FormLayoutTwo
      title="Edit Payment Terms Template"
      breadcrumbs={[
        { label: "Payment Terms Template" },
        { label: "Payment Terms Template List", url: "/master/payment-term-template/payment-term-template-list" },
      ]}
      status={'hide'}
      finalStep={finalstep}
      actionButtons={
        <>
          <Button
            onClick={() => { }}
            to="/"
            state={po_response?.result}
            style={{ backgroundColor: "#fff", height: "28px" }}
            className="custom-btn-00989blue"
            display={finalstep ? "flex" : "none"}
          >
            + Create
          </Button>

          <Button
            className="custom-btn-bluecolor d-flex"
            iconName="BiCloudUpload"
            style={{ gap: "2px" }}
            iconSize={14}
          >
            Upload
          </Button>

          <Button
            className="createbtn d-flex"
            style={{ gap: "2px", height: "28px" }}
            iconName="GrCopy"
            iconSize={12}
          >
            Duplicate
          </Button>

          <Button
            className="custom-btn-00989"
            onClick={handleSubmit}
            iconName="LuFilePlus2"
            style={{ gap: "2px", height: "28px" }}
            iconSize={12}
            display={finalstep ? "none" : "flex"}
          >
            {po_response.result ? "Submit" : "Save"}
          </Button>

          <Button
            to="/"
            className="px-2"
            imgSrc={printerimg}
            imgStyle={{ width: "21px" }}
          />
        </>
      }
    >
      <div className="d-flex flex-column" style={{ width: "100%", backgroundColor: "#fff", flexGrow: '1' }}>
        <div className="col-12 p-0" style={{ backgroundColor: "#eff4f9" }}>
          <div className="d-flex justify-content-between align-items-end ">
            <ul
              className="nav nav-tabs"
              style={{ color: "white", border: "none" }}
            >
              <li className="nav-item-tab-custom d-flex pb-0 align-items-end border-radius-top-corner">
                <a
                  className={
                    tab == 1
                      ? "removeborder234 nav-link active-tab-custom text-white border-radius-top-corner"
                      : "removeborder234 nav-link nav-link-tab-custom bg-white border-radius-top-corner"
                  }
                  onClick={() => {
                    setPageState({ ...pageState, tab: 1 })
                  }}
                  href="#"
                >
                  General Details
                  {tab == 1 ? (
                    <GetIcon iconName="MdKeyboardArrowDown" size={15} />
                  ) : (
                    <GetIcon iconName="MdKeyboardArrowRight" size={15} />
                  )}
                </a>
              </li>
            </ul>

            {/* <FileAttachmentManager
  doctype="Payment Terms Template"
  docname={IdData}
  attachments={AttachmentsList}
  setAttachments={setAttachmentsList}
/> */}

            <Attachment doctype="Payment Terms Template" docname={IdData} />
          </div>
        </div>
        <div className=" " style={{ background: '' }}>
          <div className="row">
            <div className="col-12">
              <div >
                <Tab1
                  IdData={IdData}
                  TemplateName={{
                    value: pageState.TemplateName,
                    setValue: (val) => setPageState({ ...pageState, TemplateName: val }),
                    error: fieldErrors.TemplateName,
                  }}
                  AllocatePaymentBasedOnPaymentTerms={{
                    value: pageState.AllocatePaymentBasedOnPaymentTerms,
                    setValue: (val) => setPageState({ ...pageState, AllocatePaymentBasedOnPaymentTerms: val }),
                    error: fieldErrors.AllocatePaymentBasedOnPaymentTerms,
                  }}

                  pageState={pageState}
                  setPageState={setPageState}

                  selected_payment_term_data={{
                    value: pageState.selected_payment_term_data || [],
                    setValue: (val) => setPageState({
                      ...pageState,
                      selected_payment_term_data: val,
                    }),
                  }}


                />
              </div>
            </div>
          </div>
        </div>

      </div>

      <ApiResponseBox
        poptype={ptype}
        show={showError}
        errorMessage={error}
        onClose={() => setShowError(false)}
      />
    </FormLayoutTwo>
  );
};

export default EditForm;
